// API Service Exports
export { tokenUsageApi } from './tokenUsageApi';
export type { 
  TokenUsageData, 
  ApiKeyData, 
  NotificationSettingsData 
} from './tokenUsageApi';

// Export new services
export { ConversationService } from './api/conversation';
export { AgentService } from './api/agent';
export { AppService } from './api/app';
export { getAuthHeader } from './apiConfig';
export { default as apiConfig } from './apiConfig';

// API Client for HTTP requests
export const apiClient = {
  get: (url: string, config?: any) => Promise.resolve({ data: {}, status: 200 }),
  post: (url: string, data?: any, config?: any) => Promise.resolve({ data: {}, status: 201 }),
  put: (url: string, data?: any, config?: any) => Promise.resolve({ data: {}, status: 200 }),
  delete: (url: string, config?: any) => Promise.resolve({ data: {}, status: 204 }),
  patch: (url: string, data?: any, config?: any) => Promise.resolve({ data: {}, status: 200 }),
};